module.exports = __webpack_public_path__ + "static/media/cherry-not-selected.d96d25b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/cherry-not-selected.svg
// module id = 63
// module chunks = 0